import {Object3D,Vector3,TextureLoader} from "three";
import bidello, {component} from "bidello";
import {States,stateManager} from '../../services/StateManager';
import camera from "../camera";
import {cloneMesh} from "../utils/mesh";
import {  CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer'
import {Planet} from "./Planet";
import * as THREE from 'three';
import TWEEN from 'three/examples/jsm/libs/tween.module.min';
import {viewport} from "../bidello";

export class RootView extends component(Object3D) {

    init() {

        this.safeFrameSize = viewport.isVertical ? 0.45 : 0.4
        this.name = States.root.DEFAULT_STATE;
        this.currentState = States.root.EXPLORE_STATE;
        stateManager.registerView (this,this.name);
        this.isMounted = true;
        this.viewGroup = new Object3D();

        this.exploreStateCamPos = new Vector3()
        this.visitStateCamPos = new Vector3()

        console.log("camera.getMinViewportUnitSize()",camera.getMinViewportUnitSize(),camera.getMaxViewportUnitSize())
        this.planet = new Planet();
        this.planet.setMaterial(new TextureLoader().load(require('/assets/media/textures/mzrs_diffuse.jpg')))
        //this.planet.setRealSize(Planet.REAL_SUN_SIZE);
        this.planet.revolutionDays = 30;
        this.planet.setLabelVisibility(false);
        this.planet.setAtmosphereMaterial(new TextureLoader().load(require('/assets/media/textures/planet-glow.png')),0x794537);

        this.telescopeMesh = new Object3D();

        this.defaultStateTween = new TWEEN.Tween(this.viewGroup.position)
            .easing(TWEEN.Easing.Exponential.InOut);

        this.mountTween = new TWEEN.Tween(this.viewGroup.position)
            .easing(TWEEN.Easing.Quadratic.InOut);

        this.createCSS3DElms();
        this.viewGroup.add(this.telescopeMesh);
        this.viewGroup.add(this.planet);


    }

    createCSS3DElms (){

        this.exploreTitleElm = document.body.querySelector('#intro-explore');
        this.exploreTitleCSS3D = new CSS2DObject(this.exploreTitleElm);
        this.exploreTitleCSS3D.element.addEventListener ('click',()=>{})
        this.exploreTitleCSS3D.scale.multiplyScalar(0.01)
        this.exploreTitleCSS3D.visible = false;


        this.visitTitleElm = document.body.querySelector('#intro-visit');
        this.visitTitleCSS3D = new CSS2DObject(this.visitTitleElm);
        this.visitTitleCSS3D.element.addEventListener ('click',()=>{})
        this.visitTitleCSS3D.scale.multiplyScalar(0.01)
        this.visitTitleCSS3D.position.setX(camera.calculateUnitSize().width)
        this.visitTitleCSS3D.visible = false;

    }

    onStateChange (data){

        if (!this.isMounted)return;

        if (data.state == States.root.EXPLORE_STATE)this.setExploreState();
        if (data.state == States.root.VISIT_STATE)this.setVisitState();

    }

    setDefaultState(){

        const camPos = camera.originalPosition;

        camera.tweenCameraPosition(camPos,700).onComplete(()=>{


            stateManager.addBodyState(States.root.DEFAULT_STATE);


        });
        const camTarget =  camera.controls.target.clone();
        camTarget.set (0,0,0);
        camera.tweenLookAtPosition(camTarget,700);

    }

    mountView (){

        camera.reset();
        camera.controls.enabled = false;
        this.exploreTitleCSS3D.visible = true;
        this.visitTitleCSS3D.visible = true;
        this.viewGroup.add(this.exploreTitleCSS3D);
        this.viewGroup.add(this.visitTitleCSS3D);
        this.add(this.viewGroup)
        this.isMounted = true;
        this.setMountState();

    }

    unmountView (){


        this.isMounted = false;
        this.exploreTitleCSS3D.visible = false;
        this.visitTitleCSS3D.visible = false;
        this.viewGroup.remove(this.exploreTitleCSS3D);
        this.viewGroup.remove(this.visitTitleCSS3D);

        this.remove(this.viewGroup)

    }

    setActiveState (){

        camera.controls.enabled = false;

    }

    setVisitState(){

        this.currentState = States.root.VISIT_STATE;
        this.defaultStateTween.to({x:camera.calculateUnitSize().width*-1},700).start();

    }


    setExploreState(){

        this.currentState = States.root.EXPLORE_STATE;
        this.defaultStateTween.to({x:0},700).start();

    }

    setMesh(glslMesh) {

        this.glslMesh = glslMesh;
        this.glslMesh.children.map((mesh) => {

            if (mesh.name == "telescope") {

                const clone = cloneMesh(mesh);
                clone.scale.multiplyScalar(camera.getMinViewportUnitSize()*this.safeFrameSize);


                clone.rotation.set(
                    0.1,
                    4.2,
                    5.2
                )
                this.telescopeMesh.add(clone);

            }
        })
    }

    onResize(){

        if(this.currentState == States.root.VISIT_STATE)this.viewGroup.position.setX(camera.calculateUnitSize().width*-1)
        this.telescopeMesh.position.copy(new Vector3());
        this.telescopeMesh.position.setX(camera.calculateUnitSize().width);
        this.visitTitleCSS3D.position.setX(camera.calculateUnitSize().width)

    }

    setUnmountState (){

        stateManager.removeBodyState('with-slide-selector')
        this.mountTween.to({y:1},700).start();

    }

    setMountState (){

        this.viewGroup.position.setY(-0.3)
        this.mountTween.to({y:0},700).start();
        stateManager.addBodyState('with-slide-selector')

    }

}